import scrollReveal from "../../../assets/js/composants/scrollReveal.js";
import contextMenu from "../../../assets/js/composants/contextMenu.js";

contextMenu(document.querySelectorAll('.menu-context-opener'))

scrollReveal();
window.addEventListener("scroll", scrollReveal)

const escapeHtml = (unsafe) => {
    return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}

const colorList = [
    'bleu',
    'bleu-medium',
    'bleu-clair',
    'menthe',
    'vert',
    'bordeau',
    'fushia',
    'orange',
    'noir',
    'gris',
    'glace'
]
colorList.forEach(color => {
    for (let i = 5; i < 105; i += 5) {
        const colorItem = `<div class="p-lg bg-${color}-${i}"><p class="fz-sm">.${color}-${i}</p></div>`;
        document.querySelector('.wrapper-color-transparent').innerHTML += colorItem;
    }
})
colorList.forEach(color => {

    const colorShadow = `<div class="p-lg shadow-${color} bg-blanc"><p class="fz-sm">.shadow-${color}</p></div>`;
    document.querySelector('.wrapper-color-shadow').innerHTML += colorShadow;

})

document.querySelectorAll('.html-render').forEach(render => {
    const target = render.getAttribute('data-render-to');
    const code = document.getElementById(target);
    code.append(render.innerHTML.replaceAll('                        ', '').replaceAll('<br>', ''))
    hljs.highlightAll();
});

const wrap = document.querySelector('.wrapper-icon');
fetch("../../assets/fonts/icons/icons.json")
    .then(response => {
        return response.json();
    })
    .then(data => {
        console.log(data.icons)
        for (let i = 0; i < data.icons.length; i++) {
            const icon = data.icons[i]['icon'];
            const preview = `<li class="bg-blanc bleu fz-x-normal shadow-bleu pt-lg pb-sm pb-xmd ta-center"><i class="fz-xl icon-${icon}"></i><p class="fz-xs ta-center mt-xmd">icon-${icon}</p></li>`;
            wrap.innerHTML += preview;
        }
    });